const imageDiversion = class extends HTMLElement {
  connectedCallback() {
    this.b = this.closest(".shopify-section");
    this.c = this.d = false;
    this.e = this.f = 0;

    this.g = (event) => this.h(event);
    this.i = (event) => this.j(event);
    this.k = () => this.l();
    this.m = () => this.n();

    this.b.addEventListener("pointerdown", this.g);
    this.b.addEventListener("pointermove", this.i);
    this.b.addEventListener("pointerup", this.k);
    window.addEventListener("resize", this.m);
  }
  get o() {
    return -this.offsetLeft;
  }
  get p() {
    const offsetParent = this.offsetParent;
    return offsetParent ? offsetParent.clientWidth + this.o : 0;
  }

  h(event) {
    if (event.target === this || this.contains(event.target)) {
      this.q = event.clientX - this.e;
      this.c = true;
    }
  }
  j(event) {
    if (!this.c) {
      return;
    }
    this.f = Math.min(Math.max(event.clientX - this.q, this.o), this.p);
    this.e = this.f;
    this.b.style.setProperty(
      "--image-diversion-offset",
      `${this.f.toFixed(1)}px`
    );
  }
  l() {
    this.c = false;
  }
  n() {
    this.b.style.setProperty(
      "--image-diversion-offset",
      `${Math.min(Math.max(this.o, this.f.toFixed(1)), this.p)}px`
    );
  }
};

if (!window.customElements.get("image-diversion")) {
  window.customElements.define("image-diversion", imageDiversion);
}

$(document).ready(function () {
  //variant change add to cart function
  var getUrl = window.location.href;
  if(getUrl.includes('/products/')){
  var var_id = $(document).find(".itg_varinat_btn").attr("data-variant-id");

  //alert(var_id);
  $(".shopify-product-form").find("#get_id_mian").val(var_id);
  }

  var get_id = $(document).find("#get_id_mian").val();
  if (get_id != "" && get_id != undefined) {
    $(document).find(".itg_calcContent").attr("data-box", "");
    $(document).find(".itg_calcContent").attr("product-price", "");
    // $(document).find("#sq_ft_price").text('');
    $(document).find("#ItgBoxCount").attr("data-itg", "");
    $("#custom_varaint_sel > option").each(function () {
      var ths_id = $(this).val();
      if (ths_id == get_id) {
        var ths_price = parseFloat($(this).attr("data-price"));
        var ths_sqft = parseFloat($(this).attr("data-sq"));
        if (!isNaN(ths_sqft)) {
          var sqr_per_box = ths_price / ths_sqft;
          var sqr_per_box = sqr_per_box.toFixed(2);
          $(document)
            .find(".itg_featured_product #sq_ft_price_second")
            .text("$" + sqr_per_box + "/Sq.Ft.");
          // $(document).find("#sq_ft_price").text("$" + sqr_per_box + "/Sq.Ft.");
          $(document).find(".itg_calcContent").attr("data-box", ths_sqft);
          $(document).find(".itg_calcContent").attr("product-price", ths_price);
          $(document).find("#ItgBoxCount").attr("data-itg", ths_sqft);
        }
      }
    });
  }
});


$(document).ready(function () {
  $("#box_width").on("keyup change", function () {
    var ths_width = $(this).val();
    var ths_meta = $("#ItgBoxCount").attr("data-itg");
    if (ths_width != "") {
      $(document).find("#box_length").val("");
      var itgfinal = parseFloat(ths_width) / parseFloat(ths_meta);
      var itgfinal = itgfinal.toFixed(2);
      if (itgfinal < 1) {
        var itgqut = Math.ceil(itgfinal);
      } else {
        var itgqut = Math.round(itgfinal);
      }
      $(document).find("#box_length").val(itgfinal);
      if (itgqut < 1) {
        $(document).find(".quantity").val(itgqut);
      } else {
        $(document).find(".quantity").val(itgqut);
      }
    } else {
      $(document).find("#box_length").val("");
      $(document).find(".quantity").val("");
    }
  });

  const selectors = {
    input: ".itg_drawercalc input",
    boxval: ".itg_calcContent",
  };

  function calculateArea() {
    $(document).find("#boxes_required").text("");
    $(document).find("#sq_ft_included").text("");
    $(document).find("#box_width").val("");
    $(document).find("#box_length").val("");
    var lengthdata = 0;
    var widthdata = 0;
    var final_len_width = 0;
    var total_sq_fit = 0;
    var box_price = 0;
    var waste_per = "";

    var len_popup_feet = parseFloat(
      $(selectors.input + "#len_popup_feet").val() || 0
    );

    var len_popup_inch = parseFloat(
      $(selectors.input + "#len_popup_inch").val() || 0
    );

    var width_popup_feet = parseFloat(
      $(selectors.input + "#width_popup_feet").val() || 0
    );

    var width_popup_inch = parseFloat(
      $(selectors.input + "#width_popup_inch").val() || 0
    );

    var waste_percentage = parseFloat(
      $(selectors.input + "#waste_per").val() || 0
    );

    var product_price = parseFloat(
      $(selectors.boxval).attr("product-price") || 0
    );

    var box_price = parseFloat($(selectors.boxval).attr("data-box") || 0);

    var lengthdata = len_popup_feet * 12 + len_popup_inch;

    var widthdata = width_popup_feet * 12 + width_popup_inch;

    // Total Square Footage
    var final_len_width = lengthdata * widthdata;
    var total_sq_fit = final_len_width / 144;
    var total_sq_fit = total_sq_fit.toFixed(2);

    $(document).find("#sq_ft_included").text(total_sq_fit);
    $(document).find("#box_width").val(total_sq_fit);

    // Square Per Box
    //var sqr_per_box = (product_price/box_price);
    var sqr_per_box = total_sq_fit / box_price;
    var sqr_per_box = sqr_per_box.toFixed(2);
    if (sqr_per_box < 1) {
      var itg_qty = Math.ceil(sqr_per_box);
    } else {
      var itg_qty = Math.round(sqr_per_box);
    }
    // Number of Cartons(Box)
    //var total_sqr_box = (parseFloat(total_sq_fit)/parseFloat(sqr_per_box));
    //var total_sqr_box = total_sqr_box.toFixed(2);
    //console.log('total_sqr_box:'+total_sqr_box);
    $(document).find("#boxes_required").text(sqr_per_box);
    $(document).find("#box_length").val(sqr_per_box);
    if (itg_qty < 1) {
      $(document).find(".quantity").val(itg_qty);
    } else {
      $(document).find(".quantity").val(itg_qty);
    }
    // Total Percentage Waste
    if (waste_percentage != 0) {
      var waste_per = (parseFloat(sqr_per_box) * waste_percentage) / 100;
      var waste_per = parseFloat(sqr_per_box) + parseFloat(waste_per);
      var waste_per = waste_per.toFixed(2);
      $(document).find("#boxes_required").text("");
      $(document).find("#box_length").val("");
      $(document).find("#boxes_required").text(waste_per);
      $(document).find("#box_length").val(waste_per);
      var sqr_per_boxNew = Math.round(waste_per);
      if (sqr_per_boxNew > 0) {
        $(document).find(".quantity").val(sqr_per_boxNew);
      } else {
        $(document).find(".quantity").val("1");
      }
    }
    if (waste_percentage != 0) {
      var waste_per = (parseFloat(total_sq_fit) * waste_percentage) / 100;
      var waste_per = parseFloat(total_sq_fit) + parseFloat(waste_per);
      var waste_per = waste_per.toFixed(2);
      $(document).find("#sq_ft_included").text("");
      $(document).find("#box_width").val("");
      $(document).find("#sq_ft_included").text(waste_per);
      $(document).find("#box_width").val(waste_per);
    }

    // Number of Cartons
    var number_of_cartons = parseFloat(waste_per) / parseFloat(sqr_per_box);
    var number_of_cartons = number_of_cartons.toFixed(2);
  }
  $(selectors.input).on("keyup", function () {
    calculateArea();
  });
  //variant change add to cart function

   $(document).on("click", ".itg_switch_option input", function () {
        var ths_get = $(this).val();
        $(document).find("#custom_varaint_sel > option").each(function() { 
            var ths_first = $(this).attr('data-first');
            if(ths_get == ths_first){
               var get_id = $(this).attr('value');
               $(".shopify-product-form").find("#get_id_mian").val(get_id);

                var get_price = $(this).attr('data-firstprice');
                $(document).find('.itg_price_div span.price.itg_cpm').text(get_price);

                var prodcut_handle = $(document).find('.related-product.selected-product').attr('data-get');
                if(prodcut_handle){
                     var newurl = window.location.protocol + '//' + window.location.host +'/products/'+prodcut_handle+'?variant='+get_id;
                     history.pushState({path: newurl}, '', newurl); 
                }
            
                  if (get_id != "" && get_id != undefined) {
                    $(document).find(".itg_calcContent").attr("data-box", "");
                    $(document).find(".itg_calcContent").attr("product-price", "");
                    // $(document).find("#sq_ft_price").text('');
                    $(document).find("#ItgBoxCount").attr("data-itg", "");
                    $("#custom_varaint_sel > option").each(function () {
                      var ths_id = $(this).val();
                      console.log(ths_id);
                      if (ths_id == get_id) {
                        var ths_price = parseFloat($(this).attr("data-price"));
                        var ths_sqft = parseFloat($(this).attr("data-sq"));
                        if (isNaN(ths_sqft)) {
                        } else {
                          var sqr_per_box = ths_price / ths_sqft;
                          var sqr_per_box = sqr_per_box.toFixed(2);
                          $(document)
                            .find("#sq_ft_price")
                            .text("$" + sqr_per_box + "/Sq.Ft.");
                          $(document)
                            .find("#sq_ft_price_second")
                            .text("$" + sqr_per_box + "/Sq.Ft.");
                          $(document).find(".itg_calcContent").attr("data-box", ths_sqft);
                          $(document)
                            .find(".itg_calcContent")
                            .attr("product-price", ths_price);
                          $(document).find("#ItgBoxCount").attr("data-itg", ths_sqft);
                        }
                      }
                    });
                  }
            }
        });
   });
  
  // $(document).on("click", ".itg_switch_option input", function () {
  //   var var_id = $(this).find(".itg_varinat_btn").attr("data-variant-id");
  //   //alert(var_id);
  //   $(".shopify-product-form").find("#get_id").val(var_id);

  //   var get_id = $(document).find("#get_id").val();
  //   if (get_id != "" && get_id != undefined) {
  //     $(document).find(".itg_calcContent").attr("data-box", "");
  //     $(document).find(".itg_calcContent").attr("product-price", "");
  //     // $(document).find("#sq_ft_price").text('');
  //     $(document).find("#ItgBoxCount").attr("data-itg", "");
  //     $("#custom_varaint_sel > option").each(function () {
  //       var ths_id = $(this).val();
  //       console.log(ths_id);
  //       if (ths_id == get_id) {
  //         var ths_price = parseFloat($(this).attr("data-price"));
  //         var ths_sqft = parseFloat($(this).attr("data-sq"));
  //         if (isNaN(ths_sqft)) {
  //         } else {
  //           var sqr_per_box = ths_price / ths_sqft;
  //           var sqr_per_box = sqr_per_box.toFixed(2);
  //           $(document)
  //             .find("#sq_ft_price")
  //             .text("$" + sqr_per_box + "/Sq.Ft.");
  //           $(document)
  //             .find("#sq_ft_price_second")
  //             .text("$" + sqr_per_box + "/Sq.Ft.");
  //           $(document).find(".itg_calcContent").attr("data-box", ths_sqft);
  //           $(document)
  //             .find(".itg_calcContent")
  //             .attr("product-price", ths_price);
  //           $(document).find("#ItgBoxCount").attr("data-itg", ths_sqft);
  //         }
  //       }
  //     });
  //   }
  // });

  //product page sample product drawer custom add to cart
  $(".cstmAddTocart").submit(function (e) {
    e.preventDefault(); // avoid to execute the actual submit of the form.
    var form = $(this);
    var actionUrl = form.attr("action");
    var var_id = $(this).find(".itg_hidden_input").val();
    var quantity = $(this).find(".quantity__input").val();
    
    $(this).find('.button.itg_btn img').removeClass('fadeInDown');
    $(this).find('.button.itg_btn img').addClass('zoomOut');
    var checkMark = $(this);
    $.ajax({
      type: "POST",
      url: actionUrl,
      //data: form.serialize(),
      dataType: "json",
      data: {
        quantity: quantity,
        id: var_id,
      },
      success: function (data) {
        // alert('Product added to Cart');
        //location.reload();
        checkMark.find('.button.itg_btn svg.checkmark').addClass('checkmark-active');
        setTimeout(function () {
          $.getJSON("/cart.js", function (cart) {
            var result = cart.item_count;
            $(".mini_cart").find("span.cart_count").text(result);
          });
          $(".cstmAddTocart").find('.button.itg_btn img').removeClass('zoomOut');
          $(".cstmAddTocart").find('.button.itg_btn svg.checkmark').removeClass('checkmark-active');
          $(".cstmAddTocart").find('.button.itg_btn img').addClass('fadeInDown');
          
        }, 1000);
      },
    });
  });

  //product page variant change description change
  $(document).on("change", ".itg_switch_option input[type=radio]", function () {
    var selectedVariant = $(this).attr("data-index");
    $(".itg_more_variant").css({"opacity": "0", "right": "-500px", "visibility": "hidden"});
    var selectedALt = $(this)
      .closest(".itg_switch_option")
      .find("input[type=radio]:checked+label img")
      .attr("alt");

    $(".variantDescription").hide();
    $('.variantDescription[title="' + selectedVariant + '"]').show();
    var imglen = $(
      '.template-product .itg_mergeVariant  .product__media-item[alt="' +
        selectedALt +
        '"]'
    ).length;
    if (imglen >= 1) {
      $(".template-product .itg_mergeVariant  .thumbnail-list__item").hide();
      $(".template-product .itg_mergeVariant .product__media-item").removeClass(
        "is-active"
      );
      $(
        '.template-product .itg_mergeVariant  .product__media-item[alt="' +
          selectedALt +
          '"]'
      )
        .first()
        .addClass("is-active");
      $(
        '.template-product .itg_mergeVariant .thumbnail-list__item[alt="' +
          selectedALt +
          '"]'
      )
        .first()
        .attr("aria-current", true);
      $(
        '.template-product .itg_mergeVariant .thumbnail-list__item[alt="' +
          selectedALt +
          '"]'
      ).show();
    } else {
      $(".template-product .itg_mergeVariant  .thumbnail-list__item").show();
      $(".template-product .itg_mergeVariant  .product__media-item")
        .first()
        .addClass("is-active");
    }
  });

  var itg_option_value = $(".itg_switch_option")
    .find('input[type="radio"]:checked')
    .attr("data-value");
  // alert(itg_option_value);
  $(".product-gallery__thumbnails .product-gallery__thumbnail").each(
    function () {
      var thumb_name = $(this).attr("data-title");
      //alert(thumb_name);
      if (itg_option_value == thumb_name) {
        $(this).addClass("itg_selected");
      }
    }
  );
  $(document).on(
    "change",
    '.itg_switch_option input[type="radio"]',
    function () {
      var itg_option_value = $(this).attr("data-value");
      $(".product-gallery__thumbnail").removeClass("itg_selected");
      //alert(itg_option_value);
      $(".product-gallery__thumbnails .product-gallery__thumbnail").each(
        function () {
          var thumb_name = $(this).attr("data-title");
          //alert(thumb_name);

          if (itg_option_value == thumb_name) {
            $(this).addClass("itg_selected");
          }
        }
      );
    }
  );

  //collection page list view grid view layout
  $(document).on("click", ".square-btn", function (e) {
    $(".product-list--collection").removeClass("itg_grid");
    $(".product-list--collection").removeClass("itg_list");
    if ($(this).hasClass("itg_list")) {
      $(".product-list--collection").addClass("itg_list");
      var coll_view_click = $(this).closest("li").attr("data-list");
      localStorage.setItem("collection_view", coll_view_click);
    } else if ($(this).hasClass("itg_grid")) {
      $(".product-list--collection").addClass("itg_grid");
      var coll_view_click = $(this).closest("li").attr("data-list");
      localStorage.setItem("collection_view", coll_view_click);
    }
  });

  //main banner slider home page
  $(".itg_main_banner_slider").slick({
    dots: false,
    infinite: true,
    autoplay: false,
    adaptiveHeight: true,
    autoplaySpeed: 5000,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><svg width='8' height='14' viewBox='0 0 8 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M6.81873 12.7142L0.901305 6.99993L6.81873 1.28564' stroke='#1F2126' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><svg width='8' height='14' viewBox='0 0 8 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.846375 12.7142L6.7638 6.99993L0.846375 1.28564' stroke='#1F2126' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
  });



  // selected variant options show on matching molding drawer
  $(document).on("click", ".itg_matching_open", function () {
    setTimeout(function () {
      var itg_matching_molding_var = $(
        ".related-products span.selected-product"
      ).attr("data-var-title");
      //alert(itg_matching_molding_var);
      $(".itg_matching_order ul li").hide();
      $(".itg_matching_order ul li").each(function () {
        var itg_match_product_title = $(this).attr("data-variant-title");
        // alert(itg_match_product_title);
        if (itg_matching_molding_var == itg_match_product_title) {
          $(this).show();
        }
      });
    }, 1000);
  });

  $(document).on("click", ".calcDrawerbtn", function () {
    var css_property = {
      right: 0,
      opacity: 1,
    };
    $(".itg_drawercalc").css(css_property).css("visibility", "visible");
    $("body").addClass("show_drawer");
  });

   $(document).on("click", ".faqDrawerbtn", function () {
      var css_property = {
        right: 0,
        opacity: 1,
      };
      $(".itg_drawerfaq").css(css_property).css("visibility", "visible");
   });

  $(document).on("click", ".itg_drawer_open .itg_btn", function () {
    var css_property = {
      right:0,
      opacity: 1
    }
    $('.itg_sample_order').css(css_property).css("visibility", "visible");
    $('body').addClass('show_drawer');
    $('.itg_sample_product_variant li').each(function() {
      $(this).find('.cutmButton .add_to_cart').removeClass('disabled');
      $(this).find('.cutmButton .add_to_cart').removeAttr('disabled');
    });
  });
  
  $(document).on("click", ".itg_matching_open", function () {
    var css_property = {
      right: 0,
      opacity: 1,
    };
    $(".itg_matching_order").css(css_property).css("visibility", "visible");
    $("body").addClass("show_drawer");
    $('.itg_sample_product_variant li').each(function() {
      $(this).find('.cutmButton .add_to_cart').removeClass('disabled');
      $(this).find('.cutmButton .add_to_cart').removeAttr('disabled');
    });
  });
  
  $(document).on("click", ".relatedDrawerTrigger", function () {
    var css_property = {
      right: 0,
      opacity: 1,
    };
    $(".itg_more_variant").css(css_property).css("visibility", "visible");
    $("body").addClass("show_drawer");
  });
  
  $(document).on("click", ".faqDrawerbtn", function () {
    var css_property = {
      right: 0,
      opacity: 1,
    };
    $(".itg_drawerfaq").css(css_property).css("visibility", "visible");
  });
  
  $(document).on("click", ".itg_drawer_close", function () {
    $(".itg_sample_order, .itg_matching_order, .itg_more_variant, .itg_drawercalc, .itg_drawerfaq")
      .css({"opacity": "0", "right": "-500px", "visibility": "hidden"});
    $("body").removeClass("show_drawer");
  });
  $(document).on("click", ".itg_drawer_overlay", function () {
    $(".itg_drawercalc, .itg_sample_order, .itg_matching_order, .itg_more_variant, .itg_drawerfaq")
      .css({"opacity": "0", "right": "-500px", "visibility": "hidden"});
    $("body").removeClass("show_drawer");
    $(this).closest('details.sidebar-block').removeClass('menu-opening');

    $(this).hide();
  });

  $(document).on("click", ".mobile-facets__open", function () {
    $(this).closest('.container.content').find('.content-wrapper .sidebar.toggle-all--true').addClass('filter_drawerOpen');
    $(this).closest('.container.content').find('.content-wrapper .itg_drawer_overlays').addClass('overlayOpen');
    $("body").addClass("show_drawer");
     $('.itg_drawer_overlay').show();
  });
  
  $(document).on("click", ".itg_drawer_overlays", function () {
    $(this).closest('.container.content').find('.content-wrapper .sidebar.toggle-all--true').removeClass('filter_drawerOpen');
    $(this).removeClass('overlayOpen');
    $("body").removeClass("show_drawer");
     $('.itg_drawer_overlays').hide();
  });
  
  $(document).on("click", ".itg_drawer_close", function () {
    $(this).closest('.container.content').find('.content-wrapper .sidebar.toggle-all--true').removeClass('filter_drawerOpen');
    $("body").removeClass("show_drawer");
    $('.itg_drawer_overlays').removeClass('overlayOpen');
    $('.itg_drawer_overlays').hide();
  });
  
  $(document).on("click", ".sidebar-block__heading", function () {
    $(this).closest('details.sidebar-block').addClass('menu-opening');
  });
  $(document).on("click", ".mobile-facets__close-button", function () {
    $(this).closest('details.sidebar-block').removeClass('menu-opening');
  });
});


// document.addEventListener("DOMContentLoaded", function () {
//   // Get the variant ID
//   var var_id = document
//     .querySelector(".itg_varinat_btn")
//     .getAttribute("data-variant-id");

//   // Set the variant ID value to the hidden input field with ID 'get_id'
//   document.querySelector(".shopify-product-form #get_id").value = var_id;

//   // Retrieve the value of the hidden input field with ID 'get_id'
//   var get_id = document.querySelector("#get_id").value;

//   // Check if the variant ID is valid
//   if (get_id !== "" && get_id !== undefined) {
//     document.querySelector(".itg_calcContent").setAttribute("data-box", "");
//     document
//       .querySelector(".itg_calcContent")
//       .setAttribute("product-price", "");
//     document.querySelector("#ItgBoxCount").setAttribute("data-itg", "");

//     var options = document.querySelectorAll("#custom_varaint_sel > option");
//     options.forEach(function (option) {
//       var ths_id = option.value;
//       if (ths_id == get_id) {
//         var ths_price = parseFloat(option.getAttribute("data-price"));
//         var ths_sqft = parseFloat(option.getAttribute("data-sq"));

//         if (!isNaN(ths_sqft)) {
//           var sqr_per_box = (ths_price / ths_sqft).toFixed(2);
//           document.querySelector("#sq_ft_price").innerHTML =
//             "$" + sqr_per_box + "/Sq.Ft.";
//           setTimeout(function () {
//             document.querySelector("#sq_ft_price_second").innerHTML =
//               "$" + sqr_per_box + "/Sq.Ft.";
//           }, 1000);

//           document
//             .querySelector(".itg_calcContent")
//             .setAttribute("data-box", ths_sqft);
//           document
//             .querySelector(".itg_calcContent")
//             .setAttribute("product-price", ths_price);
//           document
//             .querySelector("#ItgBoxCount")
//             .setAttribute("data-itg", ths_sqft);
//         }
//       }
//     });
//   }
// });
